export async function measurePromise<Type>(
    arg: () => Promise<Type>,
): Promise<{ res: Type, duration: number }> {
    var performance = window.performance || {};

    performance.now = (function () {
        var _now = Date.now();
        return performance.now ||
            //@ts-ignore
            performance.webkitNow ||
            //@ts-ignore
            performance.msNow ||
            //@ts-ignore
            performance.oNow ||
            //@ts-ignore
            performance.mozNow ||
            function () { return Date.now() - _now; };
    })();

    let start = performance.now();
    const res = await arg();
    const duration = Math.round(performance.now() - start);

    return { res, duration };
}